import PropTypes from 'prop-types';
import React from 'react';
import { renderRoutes } from 'react-router-config';

import MattressVariantOverview from 'pages/MattressVariantPage/OverviewContainer/OverviewContainer';
import ProductPageContainer from 'pages/ProductPage/ProductPageContainer/ProductPageContainer';

const MattressVariantPage = ({route, match}) => (
  <ProductPageContainer
    productType="mattress"
    showRatings
  >
    {match.isExact ? <MattressVariantOverview /> : renderRoutes(route.routes)}
  </ProductPageContainer>
);

MattressVariantPage.propTypes = {
  match: PropTypes.object,
  route: PropTypes.object,
};

export default MattressVariantPage;
